import styled, { css } from 'styled-components';
import { Form } from 'formik';
import { ButtonTag } from '../Button/styles';
import SectionContainer from '../SectionContainer';

export const FooterTag = styled.footer`
  position: relative;
  
  color: ${({ theme}) => theme.black};
  
  &::before {
    content: "";
    
    position: absolute;
    bottom: 0;
    left: 0;
    
    width: 100%;
    height: 125%;
    
    background-color: #f7f7f7;
  }
  
  @media(min-width: 700px) {
    &::before {
      height: 150%;
    }
  }
  
  @media(min-width: 1024px) {
    &::before {
      height: 161%;
    }
  }
  
  ${({ isInnerPage }) => isInnerPage && css`
    padding-top: ${({ checkout }) => checkout ? 0 : '40px'};
    background-color: #f8f8f8;
    
    &::before {
      display: none;
    }
    
    @media(min-width: 768px) {
      padding-top: ${({ checkout }) => checkout ? 0 : '75px'};
    }
  `}
`;

export const FooterLogo = styled.div`
  width: 140px;
  height: 32px;
  margin-bottom: 40px;
  
  svg {
    fill: ${({ theme }) => theme.blue}
  }
  
  @media(min-width: 700px) {
    width: 100%;
  }
  
  @media(min-width: 900px) {
    width: 140px;
  }
`;

export const FooterSection = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  
  &:not(:last-child) {
    margin-bottom: 30px;
  }
  
  @media(min-width: 700px) {
    &:last-child {
      width: 100%;
    }
  }
  
  @media(min-width: 1440px) {
    &:last-child {
      width: 450px;
    }
  }
`;

export const FooterSectionContainer = styled(SectionContainer)`
  flex-direction: column;
  
  @media(min-width: 700px) {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    
    &:last-child {
      width: 100%;
    }
  }
  
  ${({ isInnerPage }) => isInnerPage && css`
    @media(min-width: 1024px) {
      max-width: 1440px;
    }
  `}
`;

export const FooterSectionHeading = styled.h3`
  margin: 0;
  margin-bottom: 30px;
  padding: 0;
  
  font-size: 24px;
  line-height: 28px;
  color: ${({ theme }) => theme.blue};
`;

export const FooterList = styled.ul`

`;

export const FooterItem = styled.li`  
  &:not(:last-child) {
    margin-bottom: 15px;
  }
  
  a {
    font-size: 16px;
    line-height: 19px;
    color: inherit;
    
    transition: color 0.3s;
    
    &:hover {
      color: ${({ theme }) => theme.blue};
    }
  }
`;

export const FooterSocial = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
  @media(min-width: 700px)  {
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }
  
  @media(min-width: 1440px) {
    flex-wrap: wrap;
  }
`;

export const EmailContainer = styled(Form)`
  position: relative;
  
  max-width: 500px;
  width: 100%;
  margin-bottom: 10px;
  
  @media(min-width: 700px) {
    margin-right: 10px;
    margin-bottom: 0;
  }
`;

export const EmailInput = styled.input`
   width: 100%;
  margin-left: 5px;
  margin-right: 5px;
  padding: 20px 18px 15px 18px;
  font-size: 16px;
  line-height: 19px;
  color: inherit;
  
  border: none;
  outline: none;
  background-color: ${({ theme }) => theme.white};
  box-shadow: -1px -1px 48px 0 rgba(0, 0, 0, 0.13);
  ${'' /* border-radius: 50px; */}
  
  &::placeholder {
    color: currentColor;
    opacity: 0.5;
  }
`;

export const EmailError = styled.p`
  position: absolute;
  bottom: -30px;
  left: 0;
  
  margin: 0;
  padding: 0;
  
  font-size: 14px;
  color: ${({ theme }) => theme.red};
`;

export const EmailSuccess = styled.p`
  position: absolute;
  left: 20px;
  
  padding: 0;
  
  font-size: 14px;
  color: ${({ theme }) => theme.green};
`;

export const EmailButton = styled(ButtonTag)`
  ${'' /* position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 5px; */}
  
  padding: 12px 28px;
`;

export const DiscountMessage = styled.p`
  margin: 0;
  margin-bottom: 30px;
  font-size: 16px;
  line-height: 19px;
  padding-top: 15px;
  padding-left: 15px;
  font-weight: 400;
  
  span {
    font-weight: 700;
    color: ${({ theme }) => theme.blue};
  }
  
  @media(min-width: 700px) {
    margin-bottom: 0;
    margin-right: 30px;
  }
  
  @media(min-width: 1440px) {
    ${'' /* margin-left: auto; */}
    margin-bottom: 0;
    margin-right: 0;
  }
`;

export const SocialsList = styled.ul`
  display: flex;
  align-items: center;
  
  @media(min-width: 1440px) {
    width: 100%;
    margin-top: 70px;
  }
`;

export const SocialsItem = styled.li`
  font-size: 0;
  
  svg {
    fill: ${({ theme }) => theme.gray};
    
    transition: fill 0.3s;
    
    &:hover {
      fill: ${({ theme }) => theme.black};
    }
  }
  
  &:not(:last-child) {
    margin-right: 15px;
  }
`;

export const CopyrightContainer = styled.div`
  position: relative;
  
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: ${({ checkout }) => checkout ? 0 : '40px'};
  padding: 20px 0;
  
  color: ${({ theme }) => theme.white};
  
  background-color: ${({ theme }) => theme.black};
  
  @media(min-width: 700px)  {
  margin-top: ${({ checkout }) => checkout ? 0 : '80px'};
  }
`;

export const Copyright = styled.p`
  margin: 0;
  margin-bottom: 15px;
  padding: 0;
  
  font-size: 16px;
  line-height: 19px;
  
  @media(min-width: 700px) {
    margin-bottom: 0;
  }
`;

export const CopyrightList = styled.ul`
  display: flex;
  justify-content: space-around;
  
  li a {
    font-size: 16px;
    line-height: 19px;
    color: inherit;
  }
  
  @media(min-width: 700px) {
    li:not(:last-child) {
      margin-right: 30px;
    }
  }
`;

export const SubmitStatus = styled.p`
  display: flex;
  align-items: center;
  height: 54px;
  margin: 0;
  padding: 0;
  
  font-size: 16px;
  line-height: 1;
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;

  @media(max-width: 768px) {
    display: flex;
    flex-direction: column;
  }
`;

export const ErrorWrapper = styled.div`
  display: flex;
  justify-content: space-evenly;

  @media(max-width: 768px) {
    display: flex;
    flex-direction: column;
  }
`;

export const ErrorMessage = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 19px;
  padding-top: 20px;
  font-weight: 400;
  color: red;
`;

export const SuccessMessage = styled.p`
  margin: 0;
  margin-bottom: 30px;
  font-size: 16px;
  line-height: 19px;
  padding-top: 20px;
  font-weight: 400;
  color: green;
`;
